import httpClient from '../utils/axios'

import {
    handleServiceResponse,
    handleServiceError,
} from '../utils/serviceResponseHelper'

const getServiceConfig = async serviceId => {
    return httpClient
        .get(
            `${window.config.DOCUMENT_API_URL}/v1/serviceconfiguration/get?serviceId=${serviceId}`
        )
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

const getPagedEvents = (
    pageNumber,
    pageSize,
    isEnabled,
    isDocumentVisible,
    sortField,
    sortDirection,
    eventSetupDateTypeLookupId
) => {
    const params = {
        IsEnabled: isEnabled,
        IsDocumentVisible: isDocumentVisible,
        SortField: sortField,
        SortDirection: sortDirection,
        PageNumber: pageNumber,
        PageSize: pageSize,
        EventSetupDateTypeLookupId: eventSetupDateTypeLookupId,
    }

    const queryParams = new URLSearchParams(
        Object.entries(params).filter(([_, value]) => value != null)
    )

    const queryString = queryParams.toString()

    return httpClient.get(
        `${window.config.CONFIG_API_URL}/api/admin/events?${queryString}`
    )
}

export default {
    getServiceConfig,
    getPagedEvents,
}
